<script setup lang="ts">
/**
 * Global layout — renders MetaPixel, page content and footer on every route.
 * Cookiebot script is loaded via useHead only when explicitly enabled
 * (NUXT_PUBLIC_COOKIEBOT_ENABLED=true) so the consent banner never shows
 * during local development by default.
 */
const config = useRuntimeConfig()
const cookiebotEnabled = config.public.cookiebotEnabled as boolean

useHead({
  titleTemplate: '%sITO Consult Karriere',
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
  ],
  script: cookiebotEnabled
    ? [
        {
          id: 'Cookiebot',
          src: 'https://consent.cookiebot.com/uc.js',
          'data-cbid': '2d9706e7-bc2e-448a-9f73-39d29df7ba5b',
          'data-blockingmode': 'manual',
          type: 'text/javascript',
        },
      ]
    : [],
})
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <MetaPixel />
    <slot />
    <AppFooter />
  </div>
</template>
